import { useQuery } from "react-query";
import { CommonQueryOptions } from "../interface/UseQueryInterface";

export const useCommonQueryHook = <T>({
  queryKey,
  fetchData,
  onSuccessCallback,
}: CommonQueryOptions<T>) => {
  return useQuery<T, Error>(queryKey, fetchData, {
    staleTime: 1000 * 60 * 50,

    refetchOnWindowFocus: false,
    keepPreviousData: true,
    onSuccess: (data) => {
      onSuccessCallback?.(data);
    },
  });
};
